import { render, staticRenderFns } from "./InstructorSlider.vue?vue&type=template&id=092a44de&scoped=true&"
import script from "./InstructorSlider.vue?vue&type=script&lang=js&"
export * from "./InstructorSlider.vue?vue&type=script&lang=js&"
import style0 from "./InstructorSlider.vue?vue&type=style&index=0&id=092a44de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092a44de",
  null
  
)

export default component.exports